export default __webpack_public_path__ + "static/media/Data-Driven-Maintenance.b1e43deb.svg";